<template>
  <div>
    <div class="mb-5">
      <h1 class="text-2.5xl lg:text-3.5xl font-black mb-2">{{ $t('wizard_more_days.contact_info') }}</h1>
      <p> {{ $t('wizard_more_days.where_receive_info') }} </p>
    </div>
    <v-form v-model="valid" :disabled="formSubmitted">
      <div class="flex flex-col lg:flex-row justify-between items-center gap-2">
        <div class="w-full lg:w-1/2 font-black">
          <label for="contact_email">{{ $t('form.email') }}*</label>
          <v-text-field ref="contact_email_input" :rules="contact_form.contact_email.rules" class="avm-text-field font-normal"
            name="contact_email" v-model="contact_form.contact_email.value" outlined solo flat></v-text-field>
        </div>
        <div class="w-full lg:w-1/2 flex items-center gap-2 font-black">
          <div class="w-full">
            <label for="country_code">{{ $t('shared.country_code') }}*</label>
            <v-select ref="country_code_select" v-model="contact_form.contact_phone.country_code.value"
              :items="contact_form.contact_phone.country_code.items"
              :rules="contact_form.contact_phone.country_code.rules" class="avm-text-field font-normal" name="country_code" outlined
              solo flat required menu-props="auto"></v-select>
          </div>

          <div class="w-full">
            <label for="contact_phone">{{ $t('form.phone') }}*</label>
            <v-text-field ref="contact_phone_input" :rules="contact_form.contact_phone.number.rules"
              v-model="contact_form.contact_phone.number.value" class="avm-text-field font-normal" name="contact_phone" outlined solo
              flat></v-text-field>
          </div>
        </div>
      </div>
    </v-form>

    <div class="flex justify-start ml-2">
      <terms-component v-bind:promotions.sync="promotions" />
    </div>

    <v-btn @click="validateForm" color="secondary" class="avm-btn avm-btn--confirm mx-auto xl:block w-full" :disabled="formSubmitted">
      {{ $t('shared.continue') }}
    </v-btn>
  </div>
</template>

<script lang="ts">
import { max_value } from "vee-validate/dist/rules";
import { NIGHTS_SET_STATE, SET_CONTACT_DATA } from "../../../../../../../../store/nights/mutation-types";
import { mapMutations } from "vuex";
import phonePrefixes from "../FormAdult/phonePrefixes.js";
import { SET_TERMS } from "../../../../../../../../store/booking/mutation-types";
import { GET_TERMS } from "../../../../../../../../store/booking/getter-types";
import { NIGHTS_GET_PASSENGERS_COUNT } from "../../../../../../../../store/nights/getter-types";
import axios from "axios";

export default {
  data() {
    return {
      valid: false,
      formSubmitted: false,
      contact_form: {
        contact_email: {
          value: null,
          rules: [
            v => !!v || this.$t("form.enter_email"),
            v => /.+@.+/.test(v) || this.$t("form.invalid_email")
          ]
        },
        contact_phone: {
          country_code: {
            value: "+34 (ES)",
            items: phonePrefixes.map(
              country => `${country.dial_code} (${country.code})`
            ),
            rules: [v => !!v || this.$t("form.choose_a_country_code")]
          },
          number: {
            value: null,
            rules: [
              v => !!v || this.$t("form.enter_phone"),
              v => /^\d+$/.test(v) || this.$t("form.enter_only_digits")
            ]
          }
        }
      }
    };
  },
  computed: {
    promotions: {
        get() {
          return this.$store.state.nights.newsletter;
        },
        set(promotions) {
          this.$store.commit(NIGHTS_SET_STATE, ["newsletter", promotions]);
        },
      },
      terms() {
        return this.$store.getters[GET_TERMS].terms.value;
      },
      flight() {
        return this.$store.state.nights.flight;
      },
      passengersNumber() {
        return this.$store.getters[NIGHTS_GET_PASSENGERS_COUNT];
      }
    },
  methods: {
    ...mapMutations({
      setContactData: SET_CONTACT_DATA
    }),
    saveContactInfo() {
      if (this.valid) {
        this.setContactData({
          email: this.contact_form.contact_email.value,
          phone: this.contact_form.contact_phone.number.value,
          phone_prefix: this.contact_form.contact_phone.country_code.value
        });

        return true;
      } else {
        this.$toastr.e("Debes completar ambos campos de contacto");
        return false;
      }
    },
    validateTerms() {
      this.$store.commit(SET_TERMS, {
        ...this.$store.getters[GET_TERMS],
        terms: {
          error: !this.terms,
          value: this.terms,
        },
      });
      if (!this.terms) {
        this.$toastr.e("Debes aceptar los términos y condiciones");
        return false;
      }
      return true;
    },
    validateForm() {
      if (this.saveContactInfo() && this.validateTerms()) {
        axios.post('/api/pack/lead', {
          email: this.contact_form.contact_email.value,
          phone: this.contact_form.contact_phone.number.value,
          phone_prefix: this.contact_form.contact_phone.country_code.value,
          origin: this.flight.cityCodeFrom,
          destination: this.flight.cityCodeTo,
          passengersNumber: this.passengersNumber, 
          adults: this.$route.query.adults,
          children: this.$route.query.children,
          babies: this.$route.query.babies,
          itinerary: this.$route.query.itinerary,
          journeyFlightDate: this.$route.query.start,
          returnFlightDate: this.$route.query.end
        })
        .then(() => {
          this.formSubmitted = true;
          console.log(this.flight);
          
          this.$emit("contactFormCompleted");
        })
        .catch(error => {
          console.error("Error al enviar el formulario:", error);
          this.$toastr.e("Hubo un problema al enviar los datos. Inténtalo de nuevo.");
        });
      }
    },
  }
}

</script>
